import React from 'react';

const UserAvatar = ({ className = "w-10 h-10" }) => {
    return (
        <div className={`rounded-full bg-purple/10 flex items-center justify-center ${className}`}>
            <svg
                className="w-1/2 h-1/2 text-purple"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                />
            </svg>
        </div>
    );
};

export default UserAvatar;
